module.exports = __webpack_public_path__ + "a10371d793caf442a88fa88813dd3c2e.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/ic-loyalty.png
// module id = 949
// module chunks = 0